import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import leaf from "../../Assets/Projects/leaf.png";
import emotion from "../../Assets/Projects/emotion.png";
import editor from "../../Assets/Projects/codeEditor.png";
import chatify from "../../Assets/Projects/chatify.png";
import suicide from "../../Assets/Projects/suicide.png";
import bitsOfCode from "../../Assets/Projects/blog.png";

 let portfolio=[
        {
            title: "E-commerce",
            Technologies: "Html5, Css3 ,Bootstrap, React js, Django rest Api",
            des:"Store for selling tech products with dash admin",
            live: "https://computer-80d04.web.app/",
            github:""
        },
        {
             title: "Restaurant",
             Technologies: "Html5, Css3 ,Bootstrap, React js, Spring boot rest Api",
              des:"Pizza Restaurant with dash admin",
          live: "https://otlob-restaurant-348810.web.app/",
            github:""

        },

        {
             title: "Market",
             Technologies: "React, Html5, Css3, jQuery, Bootstrap and Firebase",
          des:"Restaurant with dash admin",
             live: "https://restaurant-1789e.web.app/",
            github:""
        },
        {
             title: "Train Booking System",
             Technologies: "Html, Css, Js, Ajax and Django",
            des:"E-commerce for booking train's tickets with dash admin",
            github: "https://github.com/EngMohamedSaeed2001/Train_Booking/tree/master",
            live: "",
        },

        {
             title: "Bank System",
             Technologies: "Java",
          des:"Bank system ",
          github: "https://github.com/EngMohamedSaeed2001/BankSystem/tree/master",
            live: "",
        },

        {
             title: "Uber System",
             Technologies: "Java",
          des:"Uber system with design pattern and oop ",
            github: "https://github.com/EngMohamedSaeed2001/Uber-software",
          live: "",
        },

    ]
function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          {portfolio.map((port, ind)=>{
            return (
                 <Col md={4} className="project-card" accessKey={ind}>
                  <ProjectCard
                    imgPath={chatify}
                    isBlog={port.github}
                    title={port.title}
                    description={port.des}
                        tech={port.Technologies}
                    demoLink={port.live}
                    github={port.github}
                  />
                </Col>
            )
          })}

        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
